<template>
  <div>
    <!--规格类别-->
    <Type :model="form"></Type>

  </div>
</template>

<script>
import Type from './many/Type.vue';

export default {
  components: {
    /*规格类别属性*/
    Type,
  },
  name: "Multiple",
  props: {
    model: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    'model': {
      handler(values, oldVal) {
        this.form = values
      },
      immediate: true,
      deep: true
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/priceStage/Stage.vue